/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 13 to version 14
 * - Fixes override items with null categoryId on their embedded component data.
 *   UTILITY-CUTOUT items get the utility-cutout category, CUTOUT items get the cutout category,
 *   and any other override item with null categoryId gets the "Other" category.
 */

const CUTOUT_CATEGORY_ID = '914f22bb-f874-4cb0-bebd-4a6d7e170ae5';
const CATEGORY_IDS: Record<string, string> = {
	'UTILITY-CUTOUT': CUTOUT_CATEGORY_ID,
	'CUTOUT': CUTOUT_CATEGORY_ID
};
const OTHER_CATEGORY_ID = '796bddfe-2031-434d-a9ae-7d24874a0c55';

export const u14 = (blueprint: any): any => {
	console.log('schema-update:process-update:14:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 14;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				const islands = [
					...(kitchen.design?.islands?.children ?? []),
					...(kitchen.design?.obstructions?.children ?? [])
				];

				islands.forEach((island: any) => {
					island.panels?.children?.forEach((panel: any) => {
						panel.panelItemGroups?.children?.forEach((group: any) => {
							group.items?.children?.forEach((panelItem: any) => {
								const { item } = panelItem;
								if (item?.override && item.component && (item.component.categoryId ?? null) === null) {
									const sku = item.component.sku?.toUpperCase() ?? '';
									item.component.categoryId = CATEGORY_IDS[sku] ?? OTHER_CATEGORY_ID;
								}
							});
						});
					});
				});
			});
		}

		console.log('schema-update:process-update:14:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:14:error', err);
		return null;
	}
};
